import * as React from 'react';

import { Divider } from '../../components/Divider';

import { VoteFragmentFragment } from '../../generated/graphql';
import { Swiper } from '../../components/LazySwiper';
import { LoadingSpinner } from '../../components/LoadingContainer';
import { PlayerAvatar } from '../../components/PlayerAvatar';

interface Props {
  votes: VoteFragmentFragment[];
}

const VoteBox = ({ vote }: { vote: VoteFragmentFragment }) => {
  return (
    <article className="space-y-4">
      <div
        className="prose"
        dangerouslySetInnerHTML={{ __html: vote.commentHtml || '' }}
      />
      <Divider />
      <div className="flex items-center">
        <PlayerAvatar player={vote.player} className="mr-2" />
        <h3 className="text-lg">{vote.player.name}</h3>
      </div>
    </article>
  );
};

export const VoteCarousel = ({ votes }: Props) => {
  return (
    <React.Suspense
      fallback={
        <div className="">
          <LoadingSpinner className="mx-auto" />
        </div>
      }
    >
      <Swiper>
        {votes.map((v) => (
          <VoteBox vote={v} key={v.id} />
        ))}
      </Swiper>
    </React.Suspense>
  );
};
